import { render, staticRenderFns } from "./AppealProcessCompleteAppRightToAppealPg.vue?vue&type=template&id=07283e30&scoped=true"
import script from "./AppealProcessCompleteAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./AppealProcessCompleteAppRightToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07283e30",
  null
  
)

export default component.exports